import React__default from 'react';
import { SearchBarCore } from '../shared/components/SearchBar.mjs';
import { Input } from './Input.mjs';

const iconContainerCommonSx = {
    zIndex: 1
};
const searchIconContainerSx = {
    ...iconContainerCommonSx,
    color: (theme)=>theme.styleConfig.inputs.placeholderColor
};
const slashIconContainerSx = {
    ...iconContainerCommonSx,
    bottom: 0,
    marginBottom: 0,
    height: '100%'
};
const slashIconSx = {
    borderColor: (theme)=>theme.styleConfig.colors.primary,
    color: (theme)=>theme.styleConfig.inputs.placeholderColor,
    fontFamily: (theme)=>theme.styleConfig.fontFamily,
    fontSize: (theme)=>theme.typography.body2.fontSize,
    lineHeight: 1,
    padding: (theme)=>theme.spacing(0.5, 1)
};
const SearchBar = (props)=>{
    return /*#__PURE__*/ React__default.createElement(SearchBarCore, {
        ...props,
        InputComponent: Input,
        searchIconContainerSx: searchIconContainerSx,
        slashIconSx: slashIconSx,
        slashIconContainerSx: slashIconContainerSx
    });
};

export { SearchBar };
//# sourceMappingURL=SearchBar.mjs.map
